import { useLayoutEffect, useState } from 'react'
import type { SidepanelState } from '@renderer/overlay/atoms'

/**
 * Mounts the open tree while the panel is still offscreen, lets layout and
 * observers settle for one complete frame, then starts motion. Hidden and peek
 * states remain lightweight.
 */
export function useStagedSidepanelMotion(sidepanelState: SidepanelState, reducedMotion: boolean): SidepanelState {
  const [motionState, setMotionState] = useState<SidepanelState>(
    sidepanelState === 'open' && !reducedMotion ? 'hidden' : sidepanelState,
  )

  useLayoutEffect(() => {
    if (sidepanelState !== 'open' || reducedMotion) {
      setMotionState(sidepanelState)
      return
    }

    let motionFrame = 0
    const layoutFrame = requestAnimationFrame(() => {
      motionFrame = requestAnimationFrame(() => setMotionState('open'))
    })
    return () => {
      cancelAnimationFrame(layoutFrame)
      cancelAnimationFrame(motionFrame)
    }
  }, [reducedMotion, sidepanelState])

  return motionState
}
